enum UserType {
    VitecUser = 'VitecUser',
    Customer = 'Customer'
}

export const getIStatusName = (v :any, type? : UserType)=> type == UserType.VitecUser ? v.vitecUser : v.customer
export default UserType;